import Navigation from "./Navigation";
import Heading from "./Heading";
const Components = {
  Navigation,
  Heading,
};

export default Components;
